var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDumbbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.17188,
    y: 8.17218,
    width: 73,
    height: 73,
    rx: 8.7875,
    fill: "#C7ABDB",
    fillOpacity: 0.31
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6234_13299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.0532 26.4447L65.6988 24.2253C64.5768 22.3869 62.1766 21.8059 60.3381 22.9279L58.1188 24.2823C56.9968 22.4438 54.5966 21.8629 52.7581 22.9848L50.5387 24.3392C48.7003 25.4612 48.1194 27.8614 49.2413 29.6999L52.6273 35.2483L32.653 47.438L29.267 41.8896C28.1451 40.0511 25.7448 39.4702 23.9063 40.5921L21.687 41.9465C19.8485 43.0685 19.2676 45.4687 20.3895 47.3072L18.1702 48.6616C16.3317 49.7835 15.7508 52.1838 16.8727 54.0222L18.2271 56.2416C16.3887 57.3636 15.8078 59.7638 16.9297 61.6023C18.0516 63.4407 20.4519 64.0217 22.2904 62.8997L23.6448 65.1191C24.7667 66.9575 27.167 67.5385 29.0054 66.4165L31.2248 65.0621C32.3467 66.9006 34.747 67.4815 36.5854 66.3595L38.8048 65.0051C40.6433 63.8832 41.2242 61.4829 40.1023 59.6445L36.7162 54.0961L56.6905 41.9064L60.0765 47.4548C61.1985 49.2933 63.5988 49.8742 65.4372 48.7523L67.6566 47.3979C69.495 46.2759 70.076 43.8757 68.954 42.0372L71.1734 40.6828C73.0118 39.5608 73.5928 37.1606 72.4708 35.3221L71.1164 33.1028C72.9549 31.9808 73.5358 29.5806 72.4139 27.7421C71.2919 25.9037 68.8917 25.3227 67.0532 26.4447ZM69.762 30.8834L68.4076 28.664C69.0204 28.2901 69.8205 28.4837 70.1945 29.0965C70.5685 29.7093 70.3748 30.5094 69.762 30.8834ZM69.819 38.4634L67.5996 39.8178L59.4732 26.5016L61.6925 25.1472C62.3054 24.7733 63.1054 24.9669 63.4794 25.5797L70.2515 36.6765C70.6254 37.2894 70.4318 38.0894 69.819 38.4634ZM66.3022 45.1785L64.0828 46.5329C63.47 46.9069 62.6699 46.7132 62.2959 46.1004L51.4607 28.3455C51.0867 27.7327 51.2803 26.9326 51.8931 26.5586L54.1125 25.2042C54.7253 24.8302 55.5254 25.0239 55.8994 25.6367L66.7346 43.3916C67.1086 44.0044 66.915 44.8045 66.3022 45.1785ZM37.4504 62.7858L35.231 64.1402C34.6182 64.5142 33.8181 64.3205 33.4442 63.7077L22.6089 45.9528C22.2349 45.34 22.4286 44.5399 23.0414 44.1659L25.2608 42.8115C25.8736 42.4375 26.6737 42.6311 27.0476 43.244L37.8829 60.9989C38.2569 61.6117 38.0632 62.4118 37.4504 62.7858ZM25.8641 63.7647L19.0921 52.6678C18.7181 52.055 18.9118 51.2549 19.5246 50.8809L21.7439 49.5265L29.8704 62.8427L27.651 64.1971C27.0382 64.5711 26.2381 64.3775 25.8641 63.7647ZM19.1491 60.2479C18.7751 59.635 18.9687 58.835 19.5815 58.461L20.936 60.6803C20.3231 61.0543 19.5231 60.8607 19.1491 60.2479ZM34.0074 49.6573L53.9817 37.4677L55.3361 39.687L35.3618 51.8767L34.0074 49.6573Z",
    fill: "#662D91"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.8184,
    y: 50.6676,
    width: 14.7382,
    height: 3,
    transform: "rotate(-31.608 31.8184 50.6676)",
    fill: "#662D91",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.4766,
    y: 67.1506,
    width: 26.2054,
    height: 6.79733,
    transform: "rotate(-120.887 33.4766 67.1506)",
    fill: "#662D91",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2734,
    y: 65.204,
    width: 15.7803,
    height: 6.79733,
    transform: "rotate(-120.887 26.2734 65.204)",
    fill: "#662D91",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.9922,
    y: 62.0316,
    width: 3.22649,
    height: 2.90726,
    transform: "rotate(-120.887 18.9922 62.0316)",
    fill: "#662D91",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6234_13299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white",
    transform: "translate(0 33.8602) rotate(-31.3943)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDumbbell);
export default __webpack_public_path__ + "static/media/dumbbell.2f8d8c4637b34ede515d4dffa4c78cf7.svg";
export { ForwardRef as ReactComponent };